import React, { useState } from "react";
import styles from "./ResetPassword.module.sass";
import TextInput from "../../components/TextInput";
import Card from "../../components/Card";
import { UseApi } from "../../hooks/use-api";
import cn from "classnames";
import Loader from "../../components/Loader";
import { ConfirmChangePassword, sendResetMail } from "../../Services/lib/auth";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import VerificationInput from "react-verification-input";
import styleMFA from "../../screens/SignIn/MFA.module.sass";
import { useHistory } from "react-router";
import Image from "../../components/Image";
import Icon from "../../components/Icon";
import auth from "../../i11/auth";
import { useUser } from "../../context";
const ResetPassword = () => {
	const [which, setWhich] = useState(0);
	const [username, setUsername] = useState("");

	const props = { which, setWhich, username };
	return (
		<div className={styles.container}>
			{
				[<Step1 setUsername={setUsername} {...props} />, <Step2 {...props} />][
					which
				]
			}
		</div>
	);
};

const Step1 = ({ setUsername, username, setWhich }) => {
	const { locale } = useUser();
	const [{ isLoading }, sendMail] = UseApi({
		service: sendResetMail,
	});

	const sendMail_ = async (e) => {
		e.preventDefault();
		const res = await sendMail(username);
		if (res) {
			ToastEmitter({
				type: "success",
				msg: `Verification code sent to your ${res.CodeDeliveryDetails.Destination} mail. Please check`,
			});
			setWhich(1);
		}
	};
	return (
		<form onSubmit={sendMail_}>
			<Image
				className={styles.pic}
				src="/images/logo-dark.png"
				srcDark="/images/logo-light.png"
				alt="Core"
			/>
			<div className={cn("h2", styles.title)}>
				{auth[locale].reset_password}
			</div>
			<Card className={styles.card}>
				{auth[locale].reset_password_disclaimer}
			</Card>
			<TextInput
				value={username}
				onChangeInput={setUsername}
				label={auth[locale].user_name}
				classLabel={styles.label}
			/>
			<button
				type="submit"
				className={cn("button", { disabled: username === "" || isLoading })}
			>
				{isLoading && <Loader />}
				{auth[locale].send_mail}
			</button>
		</form>
	);
};

export const Step2 = ({ username, modular = false, onClose }) => {
	const { locale } = useUser();
	const [{ isLoading: Mail }, sendMail] = UseApi({
		service: sendResetMail,
	});

	const sendMail_ = async (e) => {
		e.preventDefault();
		const res = await sendMail(username);
		if (res) {
			ToastEmitter({
				type: "success",
				msg: `Verification code sent to your ${res.CodeDeliveryDetails.Destination} mail. Please check`,
			});
		}
	};
	const [newPassword, setNewPassword] = useState("");
	const [repeatPassword, setRepeatPassword] = useState("");
	const [verificationCode, setVerificationCode] = useState("");
	const [passwordType, setPasswordType] = useState("password");
	const [passwordValid, setPasswordValid] = useState({
		letter: false,
		capital: false,
		number: false,
		symbol: false,
		length: false,
	});
	const history = useHistory();

	const toggle = () => {
		setPasswordType((p) => (p === "text" ? "password" : "text"));
	};

	const [{ isLoading }, confirm] = UseApi({
		service: ConfirmChangePassword,
	});

	const confirm_ = async (e) => {
		e.preventDefault();
		const res = await confirm({
			username,
			newPassword,
			verificationCode,
		});
		if (res?.$metadata) {
			ToastEmitter({
				type: "success",
				msg: `Your password has been successfully changed. ${
					!modular ? "Please login" : ""
				}`,
			});
			if (modular) {
				onClose();
			} else {
				history.push("/sign-in");
			}
		}
	};

	const changeHandler = (e) => {
		validator(e, setPasswordValid);
		setNewPassword(e);
	};

	return (
		<form autoComplete="off" onSubmit={confirm_}>
			{!modular && (
				<>
					<Image
						className={styles.pic}
						src="/images/logo-dark.png"
						srcDark="/images/logo-light.png"
						alt="Core"
					/>
					<div className={cn("h2", styles.title)}>
						{auth[locale].reset_password}
					</div>
					<Card className={styles.card}>
						{auth[locale].reset_password_verify}
					</Card>
				</>
			)}
			{modular && <div>{auth[locale].reset_password_verify}</div>}
			<VerificationInput
				autoComplete="off"
				autoFocus
				type="OTP"
				validChars="0-9"
				length={6}
				onChange={setVerificationCode}
				classNames={{
					container: styleMFA.container,
					character: `${styleMFA.bit} ${styleMFA.bg_tint_orange}`,
					characterInactive: styleMFA.bit__inactive,
					characterSelected: styleMFA.bit__selected,
				}}
			/>
			{modular && (
				<button
					onClick={sendMail_}
					type="button"
					className={cn("button-stroke", { disabled: Mail })}
				>
					{Mail && <Loader />}
					{auth[locale].send_mail}
				</button>
			)}
			<TextInput
				autoComplete="new-password"
				passwordType={passwordType}
				type={passwordType}
				onChangeInput={changeHandler}
				togglePassword={toggle}
				value={newPassword}
				label={auth[locale].password}
				classLabel={styles.label}
			/>
			{!modular ? (
				<Card className={styles.reqs}>
					<div className={passwordValid.letter && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].lower}
					</div>
					<div className={passwordValid.capital && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].capital}
					</div>
					<div className={passwordValid.number && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].number}
					</div>
					<div className={passwordValid.symbol && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].special}
					</div>
					<div className={passwordValid.length && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].min8}
					</div>
				</Card>
			) : (
				<div className={styles.reqs}>
					<div className={passwordValid.letter && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].lower}
					</div>
					<div className={passwordValid.capital && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].capital}
					</div>
					<div className={passwordValid.number && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].number}
					</div>
					<div className={passwordValid.symbol && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].special}
					</div>
					<div className={passwordValid.length && styles.valid}>
						<Icon name="check" size="16" />
						{auth[locale].min8}
					</div>
				</div>
			)}
			<TextInput
				autoComplete="new-password"
				type="password"
				onChangeInput={setRepeatPassword}
				value={repeatPassword}
				label={auth[locale].re_password}
				classLabel={styles.label}
			/>
			<button
				type="submit"
				className={cn("button", {
					disabled:
						Object.values(passwordValid).includes(false) ||
						verificationCode === "" ||
						newPassword !== repeatPassword ||
						submitValid(newPassword) ||
						isLoading,
				})}
			>
				{isLoading && <Loader />}
				{auth[locale].change_pass}
			</button>
		</form>
	);
};

const submitValid = (e) => {
	return /[A-Za-z\d@#$!_%*?&]{8,}/gm.exec(e) === null;
};

const validator = (e, setValid) => {
	setValid({
		letter: /^(?=.*[a-z])/gm.exec(e) !== null,
		capital: /^(?=.*[A-Z])/gm.exec(e) !== null,
		number: /^(?=.*\d)/gm.exec(e) !== null,
		symbol: /^(?=.*[@$#!%*?&_])/gm.exec(e) !== null,
		length: e.length >= 8,
	});
};

export default ResetPassword;
